import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "../styles/Auth.css";

const Login = () => {
  const navigate = useNavigate();

  const handleToggle = () => {
    navigate("/register");
  };

  return (
    <div className="content">
      <Sidebar />
      <div className="main-content">
        <div className="Login">
          <h1>ISN NETWORK</h1>
          <h1>Log in to ISN Network</h1>
          <div className="auth-box">
            <form className="auth-form">
              <input type="email" placeholder="Email" className="auth-input" />
              <input
                type="password"
                placeholder="Password"
                className="auth-input"
              />
              <button type="submit" className="auth-button">
                Login
              </button>
            </form>
            <p className="auth-password">
              Forgot Password? <a href="/reset-password">Reset here</a>
            </p>
            <p className="auth-toggle" onClick={handleToggle}>
              Don't have an account? Register here
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;